module.exports = __webpack_public_path__ + "media/addons/USB-20733bef.svg";